module.exports = __webpack_public_path__ + "static/mobile-apps-banner-img-tiny-896fb50d4243a610f6efed795a6824fe.jpg";